import { Box } from '@mui/material';
import { ChangeEvent, LegacyRef, useRef } from 'react';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiIconButton } from '~/legacy-components/LegacyForms';

import { LegacyMuiTextField } from '../LegacyMuiTextField';

import { useSxStyles } from './useStyles';

export const LegacyAttachmentInput = ({
  onChange,
  value,
  accept,
  error,
}: {
  onChange: (value: File | undefined) => void;
  value: string;
  accept?: string;
  error?: boolean;
}) => {
  const sxStyles = useSxStyles();

  const inputFileRef: LegacyRef<HTMLInputElement> = useRef(null);

  const handleOpenInputFilePrompt = () => {
    inputFileRef.current?.click();
  };

  const handleResetInputFile = () => {
    /* Clear hidden input file field value */
    if (!!inputFileRef.current?.value) {
      inputFileRef.current.value = '';
    }
    onChange(undefined);
  };

  const handleInputFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.files ? e.target.files[0] : undefined);
  };
  return (
    <Box sx={sxStyles.root}>
      <LegacyMuiTextField error={error} disabled value={value || ''} />
      <LegacyMuiIconButton onClick={() => handleOpenInputFilePrompt()}>
        <LegacyFAIcon FAIcon={LegacyFAIcons.Attachment} />
      </LegacyMuiIconButton>
      <LegacyMuiIconButton onClick={() => handleResetInputFile()}>
        <LegacyFAIcon FAIcon={LegacyFAIcons.Delete} />
      </LegacyMuiIconButton>

      <Box
        component={'input'}
        ref={inputFileRef}
        sx={sxStyles.fileInput}
        accept={accept}
        type="file"
        onChange={handleInputFileChange}
      />
    </Box>
  );
};
